export const AUTH_MODAL_EVENT = 'hb:open-auth-modal';

export const promptLoginForAction = (message = 'Please login first to continue.') => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AUTH_MODAL_EVENT));
  window.alert(message);
};